module.exports = __webpack_public_path__ + "static/img/invoice.81c7e301.png";